import styled from '@emotion/styled';

import { Button, tokens, Tooltip } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';

interface Props {
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  disabledTooltip?: boolean;
  disabledTooltipMessage?: string;
  formId?: string;
  children: string;
}

const S = {
  Tooltip: styled(Tooltip)`
    padding: ${tokens.spacer.x1} ${tokens.spacer.x2};
  `,
};

export function ManageSubscriptionButton({
  onClick,
  isDisabled = false,
  isLoading = false,
  disabledTooltip = false,
  disabledTooltipMessage,
  formId,
  children,
}: Props): JSX.Element {
  const { t: tSubscriptions } = useTranslationWithPrefix('checkout:subscriptions');

  const tooltipMessage = disabledTooltip
    ? disabledTooltipMessage ?? tSubscriptions('manage-subscriptions-disabled-button-tooltip')
    : '';

  const ManageButton = () => (
    <Button
      type={formId !== undefined ? 'submit' : 'button'}
      form={formId ?? undefined}
      kind="primary"
      onClick={onClick}
      isDisabled={isDisabled}
      isLoading={isLoading}
    >
      {children}
    </Button>
  );

  if (tooltipMessage !== '') {
    return (
      <S.Tooltip text={tooltipMessage} maxWidth={264}>
        <span>
          <ManageButton />
        </span>
      </S.Tooltip>
    );
  }

  return <ManageButton />;
}
